import React from 'react'
import { EMPTY_PLACEHOLDER } from '../types'

// `caption` renders as a second line inside the chip. Keeping it in the chip rather than
// under it leaves the cell with a single centred box, so the chip stays on the row's
// baseline with the neighbouring cooker chip and status badge.
const NumberChip = ({
  value,
  caption
}: {
  value: string | null
  caption?: React.ReactNode
}) => {
  if (!value) {
    return (
      <span className="number-chip number-chip--muted">
        {EMPTY_PLACEHOLDER}
      </span>
    )
  }

  if (!caption) return <span className="number-chip">{value}</span>

  return (
    <span className="number-chip number-chip--stacked">
      <span>{value}</span>
      {caption}
    </span>
  )
}

export default NumberChip
